import edenExit from './eden-exit.route';
import edenDiscipline from './eden-discipline.route';
import edenPersonnel from './eden-personnel.route';
import edenChildCount from './eden-childcount.route';
import progress from './progress.route';
import dashboard from './dashboard';
import general from './general-reports';
import StudentVisualImpairments from './eden-studentVisualImpairments';
import at from './at.route';

const routes = [
  {
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/layouts/DynamicLayout.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/views/general-reports/GeneralReportsWrapper.vue'),
        children: [
          {
            path: '/',
            name: 'general',
            component: () => import('@/views/general-reports/Menu.vue'),
          },
        ],
      },
      {
        path: '/eden',
        component: () => import('@/views/eden/EdenWrapper.vue'),
        children: [
          {
            path: '/',
            name: 'eden',
            component: () => import('@/views/eden/Menu.vue'),
          },
        ],
      },
      {
        path: '/progress',
        component: () => import('@/views/progress/ProgressWrapper.vue'),
        children: [
          {
            path: '/',
            name: 'progress',
            component: () => import('@/views/progress/Menu.vue'),
          },
        ],
      },
      {
        path: '/at',
        component: () => import('@/views/at/ATWrapper.vue'),
        children: [
          {
            path: '/',
            name: 'at',
            component: () => import('@/views/at/Menu.vue'),
          },
        ],
      },
      {
        path: '/special',
        component: () =>
          import('@/views/special-reports/SpecialReportsWrapper.vue'),
        children: [
          {
            path: '/',
            name: 'special',
            component: () => import('@/views/special-reports/Main.vue'),
            meta: { permissions: ['menu.report.specialInform.view'] },
          },
          {
            path: '/managereports/:id?',
            name: 'SpecialReportManager',
            component: () =>
              import('@/views/special-reports/SpecialReportsManager.vue'),
            meta: { permissions: ['menu.report.specialInform.view'] },
          },
        ],
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/dashboard/view',
        name: 'viewdashboard',
        component: () => import('@/views/ViewDashboard.vue'),
      },
      {
        path: '/reports/mipestudentslist',
        name: 'MiPEStudentsList',
        component: () => import('@/views/reports/ListStudentsMiPE.vue'),
      },
      {
        path: '/reports/studentcomments',
        name: 'StudentComments',
        component: () => import('@/views/reports/StudentComments.vue'),
      },
      {
        path: '/reports/coordinatedassessments',
        name: 'CoordinatedAssessments',
        component: () => import('@/views/reports/CoordinatedAssessments.vue'),
      },
      {
        path: '/reports/detailedinterviewsconducted',
        name: 'DetailedInterviewsConducted',
        component: () =>
          import('@/views/reports/DetailedInterviewsConducted.vue'),
      },
      {
        path: '/reports/executionteachers',
        name: 'TeachersExecution',
        component: () => import('@/views/reports/TeachersExecution.vue'),
      },
      {
        path: '/reports/transitionservicesassessment',
        name: 'transitionservicesassessment',
        component: () =>
          import('@/views/reports/transitionservicesassessment.vue'),
      },
      {
        path: '/reports/peicontroversy',
        name: 'PeiControversy',
        component: () => import('@/views/reports/PeiControversy.vue'),
      },
      {
        path: '/reports/federalreportindicator14',
        name: 'federalreportindicator14',
        component: () => import('@/views/reports/FederalReportIndicator14.vue'),
      },
      {
        path: '/reports/peitabIVstudentservices',
        name: 'PeiTabIVStudentServices',
        component: () => import('@/views/reports/PeiTabIVStudentServices.vue'),
      },
      {
        path: '/reports/detailedinterventionreportindicator7',
        name: 'DetailedInterventionReportIndicator7',
        component: () =>
          import('@/views/reports/DetailedInterventionReportIndicator7.vue'),
      },
      {
        path: '/reports/reasonableaccommodation',
        name: 'ReasonableAccommodation',
        component: () => import('@/views/reports/ReasonableAccommodation.vue'),
      },
      {
        path: '/reports/studentrequestlocation',
        name: 'StudentRequestLocation',
        component: () => import('@/views/reports/StudentRequestLocation.vue'),
      },
      {
        path: '/reports/interntraineeagreements',
        name: 'InternTraineeAgreements',
        component: () => import('@/views/reports/InternTraineeAgreements.vue'),
      },
      {
        path: '/reports/monitoringstudents',
        name: 'MonitoringStudents',
        component: () => import('@/views/reports/MonitoringStudents.vue'),
      },
      {
        path: '/reports/alerts',
        name: 'Alerts',
        component: () => import('@/views/reports/Alerts.vue'),
      },
      {
        path: '/reports/peirevision',
        name: 'PeiRevision',
        component: () => import('@/views/reports/PeiRevision.vue'),
      },
      {
        path: '/reports/assistancemipe',
        name: 'AssistanceMiPE',
        component: () => import('@/views/reports/AssistanceMiPE.vue'),
      },
      {
        path: '/reports/bookspurchasebycenter',
        name: 'BooksPurchaseByCenter',
        component: () => import('@/views/reports/BooksPurchaseByCenter.vue'),
      },
      {
        path: '/reports/bookspurchasesrequests',
        name: 'BooksPurchasesRequests',
        component: () => import('@/views/reports/BooksPurchasesRequests.vue'),
      },
      {
        path: '/reports/submittedinvoices',
        name: 'SubmittediInvoices',
        component: () => import('@/views/reports/SubmittediInvoices.vue'),
      },
      {
        path: '/reports/submittedreimbursement',
        name: 'SubmittedReimbursements',
        component: () => import('@/views/reports/SubmittedReimbursement.vue'),
      },
      {
        path: '/reports/transportationdetail',
        name: 'TransportationDetail',
        component: () => import('@/views/reports/TransportationDetail.vue'),
      },
      {
        path: '/reports/certificationreport',
        name: 'CertificationReport',
        component: () => import('@/views/reports/CertificationReport.vue'),
      },
      {
        path: '/reports/detailsaee10',
        name: 'Detailsaee10',
        component: () => import('@/views/reports/Detailsaee10.vue'),
      },
      {
        path: '/reports/teachersbyalternatives',
        name: 'TeachersByAlternatives',
        component: () => import('@/views/reports/TeachersByAlternatives.vue'),
      },
      {
        path: '/reports/regional-office-alternative-location-analisys',
        name: 'RegionalOfficeAlternativeLocationAnalisys',
        component: () =>
          import(
            '@/views/reports/RegionalOfficeAlternativeLocationAnalisys.vue'
          ),
      },
      {
        path: '/reports/compensatoryhours',
        name: 'CompensatoryHours',
        component: () => import('@/views/reports/CompensatoryHours.vue'),
      },
      {
        path: '/reports/paymentrefund',
        name: 'paymentrefund',
        component: () => import('@/views/reports/PaymentRefund.vue'),
      },
      {
        path: '/reports/paymentjournal',
        name: 'PaymentJournal',
        component: () => import('@/views/reports/PaymentJournal.vue'),
      },
      {
        path: '/reports/MixedServices',
        name: 'MixedServices',
        component: () => import('@/views/reports/MixedServices.vue'),
      },
      {
        path: '/reports/weeklycompliance',
        name: 'WeeklyCompliance',
        component: () => import('@/views/reports/WeeklyCompliance.vue'),
      },
      {
        path: '/reports/providerusers',
        name: 'ProviderUsers',
        component: () => import('@/views/reports/ProviderUsers.vue'),
      },
      {
        path: '/reports/specialistlicenses',
        name: 'SpecialistLicenses',
        component: () => import('@/views/reports/SpecialistLicenses.vue'),
      },
      {
        path: '/reports/registeredvisits',
        name: 'RegisteredVisits',
        component: () => import('@/views/reports/RegisteredVisits.vue'),
      },
      {
        path: '/reports/weeklyvisitsregistry',
        name: 'WeeklyVisitsRegistry',
        component: () => import('@/views/reports/WeeklyVisitsRegistry.vue'),
      },
      {
        path: '/reports/spacesavailable',
        name: 'SpacesAvailable',
        component: () => import('@/views/reports/SpacesAvailable.vue'),
      },
      {
        path: '/reports/appointmentscoordinatedevaluations',
        name: 'AppointmentsCoordinatedEvaluations',
        component: () =>
          import('@/views/reports/AppointmentsCoordinatedEvaluations.vue'),
      },
      {
        path: '/reports/invoicereport',
        name: 'InvoiceReport',
        component: () => import('@/views/reports/InvoiceReport.vue'),
      },
      {
        path: '/reports/paymentstatusofsubmittedinvoices',
        name: 'AppointmentsCoordinatedEvaluations',
        component: () =>
          import('@/views/reports/AppointmentsCoordinatedEvaluations.vue'),
      },
      {
        path: '/reports/referraldetailreport',
        name: 'ReferralDetailReport',
        component: () => import('@/views/reports/ReferralDetailReport.vue'),
      },
      {
        path: '/reports/systemgeneratedalerts',
        name: 'SystemGeneratedAlerts',
        component: () => import('@/views/reports/SystemGeneratedAlerts.vue'),
      },
      {
        path: '/reports/additionalquestionsegressprocess',
        name: 'AdditionalQuestionsEgressProcess',
        component: () =>
          import('@/views/reports/AdditionalQuestionsEgressProcess.vue'),
      },
      {
        path: '/reports/completednonconfirmedappointments',
        name: 'CompletednonConfirmedAppointments',
        component: () =>
          import('@/views/reports/CompletednonConfirmedAppointments.vue'),
      },
      {
        path: '/reports/coordinatedappointmentsnotcompleted',
        name: 'CoordinatedAppointmentsnotCompleted',
        component: () =>
          import('@/views/reports/CoordinatedAppointmentsnotCompleted.vue'),
      },
      {
        path: '/reports/schedule7-numberofyearsinsr',
        name: 'Schedule7NumberofYearsinSR',
        component: () =>
          import('@/views/reports/Schedule7NumberofYearsinSR.vue'),
      },
      {
        path: '/reports/annex14-studentsperspecialist',
        name: 'Annex14StudentSperspecialist',
        component: () =>
          import('@/views/reports/Anejo14StudentBySpecialist.vue'),
      },
      {
        path: '/reports/annex15-admissionreport',
        name: 'Annex15AdmissionReport',
        component: () => import('@/views/reports/Annex15AdmissionReport.vue'),
      },
      {
        path: '/reports/schedule16-retirementreport',
        name: 'Schedule16RetirementReport',
        component: () =>
          import('@/views/reports/Schedule16RetirementReport.vue'),
      },
      {
        path: '/reports/cseecoordinationreport',
        name: 'CSEECoordinationReport',
        component: () => import('@/views/reports/CSEECoordinationReport.vue'),
      },
      {
        path: '/reports/totallinkedreferralsperemployee',
        name: 'TotalLinkedReferralsperEmployee',
        component: () =>
          import('@/views/reports/TotalLinkedReferralsperEmployee.vue'),
      },
      {
        path: '/reports/referraldocumenttracking',
        name: 'ReferralDocumentTracking',
        component: () => import('@/views/reports/ReferralDocumentTracking.vue'),
      },
      {
        path: '/reports/umesrfindings',
        name: 'UMESRFindings',
        component: () => import('@/views/reports/UMESRFindings.vue'),
      },
      {
        path: '/reports/relatedservicemonitoring',
        name: 'RelatedServicesMonitoring',
        component: () => import('@/views/reports/RelatedServiceCompliance.vue'),
      },
      {
        path: '/reports/internsreport',
        name: 'InternsReport',
        component: () => import('@/views/reports/InternsReport.vue'),
      },
      {
        path: '/reports/supervisedreport',
        name: 'SupervisedReport',
        component: () => import('@/views/reports/Supervised.vue'),
      },
      {
        path: '/reports/comments',
        name: 'CommentsReport',
        component: () => import('@/views/reports/Comments.vue'),
      },

      {
        path: '/reports/indicator11',
        name: 'Indicator11',
        component: () => import('@/views/reports/Indicator.vue'),
      },
      {
        path: '/reports/indicator12',
        name: 'Indicator12',
        component: () => import('@/views/reports/Indicator.vue'),
      },
      {
        path: '/reports/findings',
        name: 'FindingsReport',
        component: () => import('@/views/reports/Findings.vue'),
      },
      {
        path: '/reports/2a-report',
        name: '2AReport',
        component: () => import('@/views/reports/2AReport.vue'),
      },
      {
        path: '/reports/2b-report',
        name: '2BReport',
        component: () => import('@/views/reports/2BReport.vue'),
      },
      {
        path: '/reports/3a-report',
        name: '3AReport',
        component: () => import('@/views/reports/3AReport.vue'),
      },
      {
        path: '/reports/3b-report',
        name: '3BReport',
        component: () => import('@/views/reports/3BReport.vue'),
      },
      {
        path: '/reports/specialistlicensesanddisciplines',
        name: 'SpecialistLicensesAndDisciplines',
        component: () =>
          import('@/views/reports/SpecialistLicensesAndDisciplines.vue'),
      },
      {
        path: '/reports/specialistexpiredlicenses',
        name: 'SpecialistExpiredLicenses',
        component: () =>
          import('@/views/reports/SpecialistExpiredLicenses.vue'),
      },
      {
        path: '/reports/invoice',
        name: 'Invoice',
        component: () => import('@/views/reports/Invoice.vue'),
      },
      {
        path: '/reports/paymentstatussubmittedinvoices',
        name: 'PaymentStatusSubmittedInvoices',
        component: () =>
          import('@/views/reports/PaymentStatusSubmittedInvoices.vue'),
      },
      {
        path: '/reports/information-request-report',
        name: 'RequestInfo',
        component: () => import('@/views/reports/RequestInfo.vue'),
      },
      {
        path: '/reports/requests-contracts-report',
        name: 'RequestAndContracts',
        component: () => import('@/views/reports/RequestAndContracts.vue'),
      },
      {
        path: '/reports/documents-not-submitted-report',
        name: 'UndeliveredDocuments',
        component: () => import('@/views/reports/UndeliveredDocuments.vue'),
      },
      {
        path: '/reports/contactprovider-report',
        name: 'ProviderContacts',
        component: () => import('@/views/reports/ProviderContacts.vue'),
      },
      {
        path: '/reports/activeprovider-report',
        name: 'ActiveProviders',
        component: () => import('@/views/reports/ActiveProviders.vue'),
      },
      {
        path: '/reports/2a-3a-report',
        name: 'MonthlyReport2a3a',
        component: () => import('@/views/reports/MonthlyReport2a3a.vue'),
      },
      {
        path: '/reports/documenttracking',
        name: 'DocumentTracking',
        component: () => import('@/views/reports/DocumentTracking.vue'),
      },
      {
        path: '/reports/monthly-bills-received-report',
        name: 'MonthlyReportInvoiceRP',
        component: () => import('@/views/reports/MonthlyReportInvoiceRP.vue'),
      },
      {
        path: '/reports/contract-corporation-report',
        name: 'ContractsByProvider',
        component: () => import('@/views/reports/ContractsByProvider.vue'),
      },
      {
        path: '/reports/global-bills-report',
        name: 'GlobalMonthlyInvoiceRP',
        component: () => import('@/views/reports/GlobalMonthlyInvoiceRP.vue'),
      },
      {
        path: '/reports/contracts-program-ee-report',
        name: 'ContractsProgramEeReport',
        component: () => import('@/views/reports/ContractsProgramEeReport.vue'),
      },
      {
        path: '/reports/related-services',
        name: 'RelatedServices',
        component: () => import('@/views/reports/RelatedServices.vue'),
      },
      {
        path: '/reports/scholarship-student-payments-status',
        name: 'ScholarshipStudentPaymentsStatus',
        component: () =>
          import('@/views/reports/ScholarshipStudentPaymentsStatus.vue'),
      },
      {
        path: '/reports/AvailableServices',
        name: 'AvailableServices',
        component: () => import('@/views/reports/AvailableServices.vue'),
      },
      {
        path: '/reports/student-beca',
        name: 'StudentBeca',
        component: () => import('@/views/reports/StudentBecaReport.vue'),
      },
      {
        path: '/reports/evaluation-tracking',
        name: 'EvaluationTrackingReport',
        component: () => import('@/views/reports/EvaluationTrackingReport.vue'),
      },
      {
        path: '/reports/transportation-smte',
        name: 'IntegrationEligibilityTransportation',
        component: () =>
          import('@/views/reports/IntegrationEligibilityTransportation.vue'),
      },
      {
        path: '/reports/sie-assistance',
        name: 'SieAssistance',
        component: () => import('@/views/reports/SieAssistance.vue'),
      },
      {
        path: '/reports/registerprocess',
        name: 'RegisterProcess',
        component: () => import('@/views/reports/RegisterProcess.vue'),
      },
      {
        path: '/reports/rrhh',
        name: 'RrhhReport',
        component: () => import('@/views/reports/RrhhReport.vue'),
      },
      {
        path: '/reports/TransportationEligible',
        name: 'TransportationEligible',
        component: () => import('@/views/reports/TransportationEligible.vue'),
      },
      {
        path: '/reports/billed-evaluations',
        name: 'BilledEvaluations',
        component: () => import('@/views/reports/BilledEvaluations.vue'),
      },
      {
        path: '/reports/all-student-evaluations',
        name: 'AllStudentsEvaluation',
        component: () => import('@/views/reports/AllStudentsEvaluation.vue'),
      },
      {
        path: '/reports/activeschools',
        name: 'ActiveSchoolsReport',
        component: () => import('@/views/reports/ActiveSchoolsReport.vue'),
      },
      {
        path: '/reports/query2',
        name: 'Query2',
        component: () => import('@/views/reports/Query2.vue'),
      },
      {
        path: '/reports/evaluationsaee',
        name: 'EvaluationSaee',
        component: () => import('@/views/reports/EvaluationSaee.vue'),
      },
      {
        path: '/reports/evaluationsrp',
        name: 'EvaluationRP',
        component: () => import('@/views/reports/EvaluationRP.vue'),
      },
      {
        path: '/reports/monitoringmipe',
        name: 'MonitoringMipeStudents',
        component: () => import('@/views/reports/MonitoringMipeStudents.vue'),
      },
      {
        path: '/reports/saeevisitregistry',
        name: 'SAEEVisitRegistryReport',
        component: () => import('@/views/reports/SAEEVisitRegistry.vue'),
        meta: {
          permissions: ['menu.report.dashboard.view.reportsaeevisitregistry'],
        },
      },
      {
        path: '/reports/rpvisitregistry',
        name: 'RPVisitRegistry',
        component: () => import('@/views/reports/RPVisitRegistry.vue'),
      },
      {
        path: '/reports/visitreport',
        name: 'visitreport',
        component: () => import('@/views/reports/visitreport.vue'),
      },
      {
        path: '/reports/pei-additional-questions',
        name: 'PeiAdditionalQuestions',
        component: () => import('@/views/reports/PeiAdditionalQuestions.vue'),
      },
      {
        path: '/reports/estipulacion-49-san-juan',
        name: 'Stipulation49SanJuan',
        component: () => import('@/views/reports/Stipulation49SanJuan.vue'),
      },
      {
        path: '/reports/proposalrequestcontract',
        name: 'ProposalRequestContract',
        component: () => import('@/views/reports/ProposalRequestContract.vue'),
      },
      {
        path: '/reports/technicalasistanceandteachingsupport',
        name: 'TechnicalAsistanceAndTeachingSupport',
        component: () => import('@/views/reports/TechnicalAsistanceAndTeachingSupport.vue'),
      },
      {
        path: '/reports/therapyevaluationquestionaire',
        name: 'TherapyEvaluationQuestionaire',
        component: () => import('@/views/reports/TherapyEvaluationQuestionaire.vue'),
        meta: {
          permissions: ['menu.inf.therapyevaluationquestionaire'],
        },
      },
      {
        path: '/reports/tapdisburstmentrequeststudenteligibility',
        name: 'TapDisburstmentRequestStudentEligibilityVue',
        component: () => import('@/views/reports/TapDisburstmentRequestStudentEligibility.vue'),
        meta: {
          permissions: ['menu.inf.tapdisburstmentrequeststudenteligibility'],
        },
      },
      {
        path: '/reports/specialist-absences-report',
        name: 'SpecialistAbsencesReport',
        component: () => import('@/views/reports/SpecialistAbsencesReport.vue'),
      },
      {
        path: '/reports/tapdisburstmentrequeststudenteligibilityapproved',
        name: 'TapDisburstmentRequestStudentEligibilityApprovedVue',
        component: () => import('@/views/reports/TapDisburstmentRequestStudentEligibilityApproved.vue'),
        meta: {
          permissions: ['menu.inf.tapdisburstmentrequeststudenteligibilityapproved'],
        },
      },
      {
        path: '/reports/peistudentsabaservice',
        name: 'PEI_StudentsABAService',
        component: () => import('@/views/reports/PEI_StudentsABAService.vue'),
        meta: {
           permissions: ['menu.report.peiabaservice'],
        },
      },
      {
        path: '/reports/billed-providers',
        name: 'ProviderBills',
        component: () => import('@/views/reports/ProviderBills.vue'),
        meta: {
           permissions: ['menu.inf.providerusers'],
        },
      },
      {
        path: '/reports/equitativeservices',
        name: 'EquitativeServices',
        component: () => import('@/views/reports/EquitativeServices.vue'),
        meta: {
           permissions: ['menu.inf.equitativeservices'],
        },
      },
      {
        path: '/reports/eligiblestudentaee/:type',
        name: 'EligibleStudentAee',
        component: () => import('@/views/reports/EligibleStudentAee.vue'),
      },    
      ...edenExit,
      ...edenDiscipline,
      ...edenPersonnel,
      ...edenChildCount,
      ...progress,
      ...dashboard,
      ...general,
      ...StudentVisualImpairments,
      ...at,
    ],
  },
  {
    path: '*',
    redirect: { name: 'general' },
  },
];

export default routes;
